import { useSearchParams } from 'next/navigation';

import { PresentationalFilterFacet } from '../types';
import useUpdatePath from './useUpdatePath';

interface UpdateQueryStringParams {
  setPath: (pathToSet: string) => void;
  path: string;
  pathname: string;
  isDevelopment: boolean;
  filters?: PresentationalFilterFacet[];
}

type QueryStringProps = {
  name: string;
  value?: string;
};

export default function useUpdateQueryString({
  setPath,
  path,
  pathname,
  isDevelopment,
  filters = []
}: UpdateQueryStringParams) {
  const searchParams = useSearchParams();
  const { updatePath } = useUpdatePath(setPath, pathname, isDevelopment);

  const updateQueryString = (
    queryParams: QueryStringProps | QueryStringProps[],
    callback?: () => void
  ) => {
    const params = new URLSearchParams(searchParams?.toString() || '');
    const paramsToUpdate = Array.isArray(queryParams) ? queryParams : [queryParams];
    paramsToUpdate.forEach(({ name, value }) => {
      if (value) {
        params.set(name, value);
      } else {
        params.delete(name);
      }
    });

    if (callback) callback();
    updatePath(path, filters, params);
  };

  return { updateQueryString };
}
